import { render, staticRenderFns } from "./SmspayRedirect.vue?vue&type=template&id=531f0463&scoped=true"
import script from "./SmspayRedirect.vue?vue&type=script&lang=js"
export * from "./SmspayRedirect.vue?vue&type=script&lang=js"
import style0 from "./SmspayRedirect.vue?vue&type=style&index=0&id=531f0463&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531f0463",
  null
  
)

export default component.exports